import update from 'immutability-helper'

import { ChatDisplayState, ChatState } from '../../models/chat'

import {
  CHAT_FORM_OPENED,
  CHAT_STARTED,
  CHAT_TOKEN,
  CHAT_REQUESTED,
  CHAT_NEW_MESSAGE,
  CHAT_CLEAR,
  CHAT_SYSTEM_MESSAGE,
  CHAT_PEN_STATE,
  CHAT_QUEUED,
  CHAT_FINISHED,
  CHAT_ENTRANCE_CLOSED,
  CHAT_MINIMIZE,
  CHAT_API_INITIALIZED,
  CHAT_CLOSE_WARNING,
} from '../actions/action-types'

const initialState = {
  errand: '',
  msg: '',
  displayState: ChatDisplayState.MINIMIZED,
  chatState: ChatState.NONE,
  history: [],
  systemMessage: '',
  penState: false,
  queueInfo: {},
  previousDisplayState: ChatDisplayState.NONE,
  servingAgent: '',
  configuration: {
    errandTypes: [],
    openTime: '08:00',
    closeTime: '17:00',
  },
  token: null,
}

// eslint-disable-next-line default-param-last
const chat = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_FORM_OPENED: {
      const newDisplayState =
        state.previousDisplayState === ChatDisplayState.NONE
          ? ChatDisplayState.REQUEST_FORM
          : state.previousDisplayState
      return update(state, {
        displayState: { $set: newDisplayState },
      })
    }
    case CHAT_TOKEN:
      return update(state, {
        token: { $set: action.response.token },
      })
    case CHAT_REQUESTED:
      return update(state, {
        errand: { $set: action.errand },
        chatState: { $set: ChatState.CONNECTING },
      })
    case CHAT_STARTED:
      return update(state, {
        servingAgent: { $set: action.agent },
        chatState: { $set: ChatState.ONGOING },
        displayState: { $set: ChatDisplayState.CHAT_OPENED },
      })
    case CHAT_NEW_MESSAGE: {
      const newDisplayState =
        state.displayState === ChatDisplayState.MINIMIZED
          ? state.previousDisplayState
          : state.displayState
      return update(state, {
        history: { $push: [action.msg] },
        displayState: { $set: newDisplayState },
      })
    }
    case CHAT_SYSTEM_MESSAGE:
      return update(state, {
        systemMessage: { $set: action.msg },
      })
    case CHAT_CLEAR: {
      return update(state, {
        errand: { $set: '' },
        msg: { $set: '' },
        displayState: { $set: ChatDisplayState.MINIMIZED },
        chatState: { $set: ChatState.NONE },
        history: { $set: [] },
        systemMessage: { $set: '' },
        penState: { $set: false },
        queueInfo: { $set: {} },
        servingAgent: { $set: '' },
        previousDisplayState: { $set: ChatDisplayState.NONE },
      })
    }
    case CHAT_PEN_STATE: {
      return update(state, {
        penState: { $set: action.state },
      })
    }
    case CHAT_QUEUED: {
      return update(state, {
        chatState: { $set: ChatState.ONGOING },
        displayState: { $set: ChatDisplayState.CHAT_IN_QUEUE },
        queueInfo: { $set: action.info },
      })
    }
    case CHAT_FINISHED: {
      if (
        // don't show post-process window if chat hasn't been established
        state.displayState === ChatDisplayState.CHAT_IN_QUEUE ||
        state.displayState === ChatDisplayState.REQUEST_FORM ||
        state.chatState === ChatState.NONE
      ) {
        return update(state, {
          errand: { $set: '' },
          displayState: { $set: ChatDisplayState.MINIMIZED },
          chatState: { $set: ChatState.NONE },
          history: { $set: [] },
          systemMessage: { $set: '' },
          penState: { $set: false },
          queueInfo: { $set: {} },
          servingAgent: { $set: '' },
          previousDisplayState: { $set: ChatDisplayState.NONE },
        })
      }
      return update(state, {
        displayState: { $set: ChatDisplayState.FINISHED },
      })
    }
    case CHAT_ENTRANCE_CLOSED: {
      return update(state, {
        displayState: { $set: ChatDisplayState.CHAT_ENTRANCE_CLOSED },
      })
    }
    case CHAT_MINIMIZE: {
      return update(state, {
        previousDisplayState: { $set: state.displayState },
        displayState: { $set: ChatDisplayState.MINIMIZED },
        errand: { $set: action.errandType || '' },
        msg: { $set: action.msg || '' },
      })
    }
    case CHAT_API_INITIALIZED: {
      return update(state, {
        apiInitialized: { $set: true },
      })
    }
    case CHAT_CLOSE_WARNING: {
      return update(state, {
        displayState: { $set: ChatDisplayState.BEFORE_CLOSE },
      })
    }
    default:
      return state
  }
}

export default chat
